export default "__VITE_ASSET__BtU8v6Oj__"